import {defineComponent} from 'vue';
import {useFormatting} from "@/composables/currency-format.ts";

export default defineComponent({
    name: 'AegCompanyInfo',
    props: {
        name: {
            type: String,
            required: true,
        },
        identifier: {
            type: String,
            required: false,
        },
        vatNumber: {
            type: String,
            required: false,
        }
    },
    setup() {
    }
})
